/**
 * @flow
 * @relayHash 93ae048206d1de9acf2bd93cb7c21e69
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
};
export type UserPlaylist_updatePlaylistMutationVariables = {|
  input: UpdatePlaylistInput
|};
export type UserPlaylist_updatePlaylistMutationResponse = {|
  +updatePlaylist: ?{|
    +playlist: ?{|
      +title: ?string,
      +description: ?string,
    |}
  |}
|};
export type UserPlaylist_updatePlaylistMutation = {|
  variables: UserPlaylist_updatePlaylistMutationVariables,
  response: UserPlaylist_updatePlaylistMutationResponse,
|};
*/


/*
mutation UserPlaylist_updatePlaylistMutation(
  $input: UpdatePlaylistInput!
) {
  updatePlaylist(input: $input) {
    playlist {
      title
      description
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlaylistInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdatePlaylistInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UserPlaylist_updatePlaylistMutation",
  "id": null,
  "text": "mutation UserPlaylist_updatePlaylistMutation(\n  $input: UpdatePlaylistInput!\n) {\n  updatePlaylist(input: $input) {\n    playlist {\n      title\n      description\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserPlaylist_updatePlaylistMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlaylistPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "Playlist",
            "plural": false,
            "selections": [
              v2,
              v3
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UserPlaylist_updatePlaylistMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlaylistPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "Playlist",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '198afe1ca2acdb1dcd7d59c48cf8b8aa';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/App/__generated__/UserPlaylist_updatePlaylistMutation.graphql.js